import { createContext } from "react";

import { DefaultContext } from "constants/context/context";

const LoginContext = createContext(DefaultContext);

export default LoginContext;
